import type { FieldState } from '@/utils/field-state'

/**
 * PrimeVue ships its CSS unlayered, so it beats `@layer components` — `.finest-field`
 * cannot reach a PrimeVue input. These are its `!`-twins: same tokens, deliberately
 * duplicated instead of abstracted across the layer boundary.
 */

/** Focus ring of `.finest-field`. */
export const primeInputFocus = 'enabled:focus:border-action! enabled:focus:ring-[3px]! enabled:focus:ring-action/35!'

/** Warn state of `.finest-field--missing`. */
export const primeInputMissing =
  'border-warning! border-dashed! bg-warning-subtle! text-warning! font-medium! placeholder:text-warning! placeholder:opacity-100!'

/** Origin state of `.finest-field--auto`. */
export const primeInputAuto = 'border-auto-line! hover:border-action!'

/** Origin state of `.finest-field--reading`. */
export const primeInputReading = 'border-auto-line! bg-auto-subtle! placeholder:text-auto! placeholder:opacity-100!'

export const primeInputState = (state?: FieldState | null): string => {
  switch (state) {
    case 'missing':
      return primeInputMissing
    case 'auto':
      return primeInputAuto
    case 'reading':
      return primeInputReading
    default:
      return ''
  }
}
